<template>		
  <el-container style="height: 100%; width: 100%;">
    
      <router-view></router-view>
    </el-main>
    <el-footer>
		<div style="display: flex;width: 100%;height: 5vw;align-items: center;">
				<span style="display: flex;align-items: center;color: white;font-size: 2vw;margin-left: 5vw;">Copyright © 2019 laboratory-lucchini All Rights Reserved</span>
		</div>
	</el-footer>
  </el-container>
</template>

<script scoped>
export default {

  data() {
    return {
      activeName: 'second',
	  activeIndex: '1', // 或者设置为你需要的默认值
	  show3: false
    };
  },
  mounted() {
  },
  methods: {
	  navigateToProcessingCenter() {
	      this.$router.push('/processing-center');
	    },
	  toggleMenu() {
	        this.show3 = !this.show3;
	      },
    handleSelect(index) {
      if (index === '1') {
        this.$router.push({ name: 'ProcessingCenter' });
      } else if (index === '2') {
        this.$router.push({ name: 'MyPage' });
      } else if (index === '3') {
        this.$router.push({ name: 'MessageCenter' });
      } else if (index === '4') {
        this.$router.push({ name: 'OrderManagement' });
      }else if (index === '5') {
        this.$router.push({ name: 'shou' });
      }else if (index === '6') {
        this.$router.push({ name: 'ver' });
      }
    },
    
	
  }
};
</script>
<style>
	::-webkit-scrollbar {
	    display: none; /* 隐藏滚动条 */
	}
</style>
<style scoped>
	/* banner三条横线——菜单 start */
	.banner_menu {
	  height: 7vh;
	  position: absolute;
	  right: 5%;
	  width: 9vh;
	  cursor: pointer;
	}
	.banner_menu s {
	  background-color: #000;
	  position: absolute;
	  width: 6vw;
	  height: 1vw;
	  transition: all 0.5s ease;
	  transform-origin: center;
	}
	.banner_menu s:first-child {
	  top: 0;
	}
	.banner_menu s:nth-child(2) {
	  top: 2vw;
	}
	.banner_menu s:nth-child(3) {
	  top: 4vw;
	}
	.changeFigure s:first-child {
	  transform: rotate(45deg) translate(1px);
	  top: 2vw;
	}
	.changeFigure s:nth-child(2) {
	  transform: scaleX(0);
	  opacity: 0;
	}
	.changeFigure s:nth-child(3) {
	  transform: rotate(-45deg) translate(0);
	  top: 2vw;
	}

	.transition-box {
	    width: 100%;
	    height: 15vw;
	    background-color: #30344d;
	    text-align: center;
	    color: #fff;
		display: flex;
	    box-sizing: border-box;
		align-items: center;
		font-size: 5vw;
		font-weight: 600;
		padding-left: 10%;
	  }
	.el-menu-item:hover {
	  color: #000 !important;
	  background-color: #cfcfcf !important;
	}
	
	/* 修改 el-menu-item 选中时的样式 */
	.el-menu-item.is-active {
	  color: #000 !important;
	  background-color: #cfcfcf !important;
	}
	/* //去掉选中el-menu-item时的下划线 */
	.el-menu--horizontal > .el-menu-item {
	  border-bottom: none !important;
	}
 .el-header{
	 background-color: #cfcfcf;
	 color: #333;
	 text-align: center;
	 width: 100%;
	 margin: 0;
	 padding: 0;
	 display: flex;
	 font-size: 1vw;
 }
 .el-footer {
  /* background-color: #a5a5a5; */
  color: #333;
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  font-size: 1vw;
  background-color: #333;
  align-items: center;
}

.el-main {

  color: #333;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0;

}
/* .el-dropdown-menu__item:hover {
  background-color:#fcc93a !important;
  color: #000 !important;
  padding-left: 5%;
} */

body {
  margin: 0;
  padding: 0;
  /* overflow: hidden; */
  
}

/* 添加媒体查询，根据屏幕宽度调整样式 */
@media (max-width: 768px) {
	img {
	    width: 100%;
	    height: auto;
	  }
  .el-header div {
    flex-wrap: wrap;
  }

  .el-header div > div {
    flex: 0 0 100%;
    text-align: center;
	
  }
}
.btn{
cursor:pointer;
	position:relative;
	/* padding:10px 20px; */
	background:white;
	font-size:15px;
	border-top-right-radius:10px;
	border-bottom-left-radius:10px;
	transition:all 1s;
	&:after,&:before{
		content:" ";
		width:10px;
		height:10px;
		position:absolute;
		border :0px solid #fff;
		transition:all 1s;
		}
	&:after{
		top:-1px;
		left:-1px;
		border-top:5px solid #fcc93a;
		border-left:5px solid #fc90dc;
	}
	&:before{
		bottom:-1px;
		right:-1px;
		border-bottom:5px solid #fcc93a;
		border-right:5px solid #fc90dc;
	}
	&:hover{
		border-top-right-radius:0px;
	border-bottom-left-radius:0px;

		&:before,&:after{
			
			width:100%;
			height:100%;

		}
	}
}
.btn2 {
  flex: 1 1 auto;

  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
 /* text-shadow: 0px 0px 10px rgba(0,0,0,0.2);*/
  box-shadow: 0 0 20px #eee;
  border-radius: 10px;
 }

/* Demo Stuff End -> */

/* <- Magic Stuff Start */

.btn2:hover {
  background-position: right center; /* change the direction of the change here */
}

.btn-1 {
  background-image: linear-gradient(to right, #f6d365 0%, #fda085 51%, #f6d365 100%);
}

.btn-2 {
  background-image: linear-gradient(to right, #fbc2eb 0%, #a6c1ee 51%, #fbc2eb 100%);
}

.btn-3 {
  background-image: linear-gradient(to right, #84fab0 0%, #8fd3f4 51%, #84fab0 100%);
}

.btn-4 {
  background-image: linear-gradient(to right, #a1c4fd 0%, #c2e9fb 51%, #a1c4fd 100%);
}

.btn-5 {
  background-image: linear-gradient(to right, #ffecd2 0%, #fcb69f 51%, #ffecd2 100%);
}
</style>
